import { useEffect, useState, useRef } from "react";
import Seat from "./Seat";
import StrokeCS from "./StrokeCS";
import { rowsChart } from "./rowsChart";
import * as XLSX from 'xlsx';


function TungSVG_Ok({wkSheet, nameEvent, datetimeEvent }) {
  const [seats, setSeats] = useState([]);
  const [highlightColors, setHighlightColors] = useState(new Set());
  const [hoverSeat, setHoverSeat] = useState(null);
  const [groupSeatingChart, setGroupSeatingChart] = useState([]);

useEffect(() => {
    fetch("/chartSeat-DaiHoi-9.xlsx") // lấy từ thư mục public
      .then((res) => res.arrayBuffer())
      .then((arrayBuffer) => {
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[wkSheet];
        const worksheet = workbook.Sheets[sheetName];
        const rawData = XLSX.utils.sheet_to_json(worksheet,{ header: 1 });
        // dạng mảng 2D
        const parsed = [];
        rawData.slice(1).forEach((row) => {// Bỏ dòng tiêu đề (row đầu tiên)
        const [labelGroup, colorGroup, ...positions] = row;
        if (labelGroup && colorGroup && positions.length > 0) {
          parsed.push({
            labelGroup: labelGroup.toString().trim(),
            colorGroup: colorGroup.toString().trim(),
            position: positions
              .filter(Boolean) // loại bỏ ô trống
              .map(p => p.toString().trim())
          });
        }
      });
      setGroupSeatingChart(parsed);
      // console.log(">> groupSeatingChart:", parsed);
      });
  }, []);


useEffect(() => {
    const seatPositionToColor = {};

    groupSeatingChart.forEach((group) => {
        const color = group.colorGroup; // lấy trực tiếp màu từ object
    
        group.position.forEach(pos => {
          seatPositionToColor[pos] = {
            color,
            labelGroup: group.labelGroup
          };
        });
      });

    // console.log("seatPositionToColor: ",seatPositionToColor);
//-------------------------------------------------------------------------------------
    const newSeats = [];

    rowsChart.forEach((rowN, indexRow)=>{
      let seatNum = 1;
      const rowChar = rowN.labelRow;
      rowN.coordinates.forEach((coor,indexCoor)=>{
        const seatNumber = seatNum++;
        const positionKey = `${rowChar}${seatNumber}`;
        const config = seatPositionToColor[positionKey];
        const color = config?.color || "#DDD";
        const labelGroup = config?.labelGroup || null;

        newSeats.push({ cx:coor.cx, cy:coor.cy, seatNumber, color, rowChar, positionKey, labelGroup });
      })
    });

    
    // console.log("newSeats: ",newSeats);
//=======================================================================================
    setSeats(newSeats);
  }, [groupSeatingChart]);

  const handleClick = (seat) => {
    const newSet = new Set(highlightColors);
    if (newSet.has(seat.color)) {
      newSet.delete(seat.color);
    } else {
      newSet.add(seat.color);
    }
    setHighlightColors(newSet);
  };

  // nhóm seats theo rowChar
  const seatsByRow = {};
  seats.forEach((s) => {
    if (!seatsByRow[s.rowChar]) seatsByRow[s.rowChar] = [];
    seatsByRow[s.rowChar].push(s);
  });
  // console.log("seatsByRow: ", seatsByRow);
  
  const listDarkColor = new Set([
    "#000066",
    "#000099",
    "#0000CC",
    "#0000DD",
    "#0000FF",
    "#003300",
    "#003366",
    "#003399",
    "#0033CC",
    "#005500",
    "#006600",
    "#006633",
    "#006666",
    "#006699",
    "#0066CC",
    "#0066FF",
    "#008000",
    "#008080",
    "#009900",
    "#009999",
    "#0099CC",
    "#00CC00",
    "#333300",
    "#333399",
    "#3333CC",
    "#3333FF",
    "#336600",
    "#336633",
    "#336699",
    "#3366CC",
    "#3366FF",
    "#339933",
    "#339966",
    "#660033",
    "#660066",
    "#6600CC",
    "#6600FF",
    "#663300",
    "#663333",
    "#666600",
    "#666633",
    "#666699",
    "#6666FF",
    "#669900",
    "#669933",
    "#800000",
    "#800080",
    "#808000",
    "#833C0C",
    "#990000",
    "#990033",
    "#990066",
    "#990099",
    "#9900CC",
    "#9900FF",
    "#993300",
    "#993333",
    "#993366",
    "#9933FF",
    "#996600",
    "#996633",
    "#A50021",
    "#C00000",
    "#CC0000",
    "#CC0066",
    "#CC0099",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3399",
    "#CC6600",
    "#D60093",
    "#FF0000",
    "#FF0066",
    "#FF3300"

  ]);
  // ---------------- Tooltip with accurate text width ----------------
  const [tooltipWidth, setTooltipWidth] = useState(0);
  const textRef = useRef(null);

  useEffect(() => {
    if (hoverSeat && textRef.current) {
      const len = textRef.current.getComputedTextLength();
      console.log("độ dài của xâu ghi chú:", len);
      
      setTooltipWidth(len + 10); // padding
    }
  }, [hoverSeat]);

  return (
    <>
      <h1>Sơ đồ chỗ ngồi - {nameEvent}</h1>
      <p>Thời gian: {datetimeEvent}</p>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="2826.295px"
        height="2650.823px"
        viewBox="0 0 2826.295 2650.823"
        enableBackground="new 0 0 2826.295 2650.823"
        xmlSpace="preserve"
        style={{ border: "1px solid #ccc", background: "#f9f9f9", cursor: "pointer" }}
        // transform="scale(0.5,0.5)"
        onClick={() => setHighlightColors(new Set())} // click nền → reset
      >
      {/* 6 khu vực */}
      <text dy="0.7em" x="726.6039" y="1137.8248" fontFamily="Times New Roman" fontSize={290} opacity={0.17}>1</text>
      <text dy="0.7em" x="1338.2017" y="1220.542" fontFamily="Times New Roman" fontSize={290} opacity={0.17}>2</text>
      <text dy="0.7em" x="1967.4943" y="1117.075" fontFamily="Times New Roman" fontSize={290} opacity={0.17}>3</text>
      <text dy="0.7em" x="751.442" y="1764.307" fontFamily="Times New Roman" fontSize={290} opacity={0.17}>4</text>
      <text dy="0.7em" x="1335.3887" y="1834.5" fontFamily="Times New Roman" fontSize={290} opacity={0.17}>5</text>
      <text dy="0.7em" x="1925.4058" y="1785.7864" fontFamily="Times New Roman" fontSize={290} opacity={0.17}>6</text>

        <StrokeCS />
        {/* Vẽ từng ghế */}
        {seats.map((seat, idx) => {
          const isHighlighted = highlightColors.has(seat.color);
          return (
            <g
              key={idx}
              onClick={(e) => {
                e.stopPropagation(); // không cho click ghế lan ra svg
                handleClick(seat)}}
              onMouseEnter={() => setHoverSeat(seat)}
              onMouseLeave={() => setHoverSeat(null)}
            >
              <Seat
                key={idx}
                cx={seat.cx}
                cy={seat.cy}
                label={seat.seatNumber}
                fill={seat.color}
                stroke={isHighlighted ? "#000" : "#333"}//"red" || listDarkColor.has(seat.color) ? "yellow" : "red"
                strokeWidth={isHighlighted ? 3 : 1}
                labelColor={listDarkColor.has(seat.color) ? "#fff" : "#000"} //seat.color==="#DDD"? "#000" : "#fff"  ghế có đoàn thì chữ trắng, ko có đoàn thì chữ đen
              />
            </g>
          );
        })}

        {/* Vẽ ký hiệu hàng ghế (bên trái và phải) */}
        {Object.values(seatsByRow).map((rowSeats, i) => {
          const firstSeat = rowSeats[0];                      // ghế đầu tiên (trái)
          const lastSeat = rowSeats[rowSeats.length - 1];     // ghế cuối cùng (phải)
          const label = rowSeats[0].rowChar;

          // ❌ bỏ qua các label không cần hiển thị
          if (["SE", "VIPa", "VIPb", "VIPc"].includes(label)) {
            return null;
          }

          return (
            <g key={`row-${i}`}>
              <text
                x={firstSeat.cx + 30}//bên phải
                y={firstSeat.cy - 10}
                fontSize="16"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="#000"
              >
                {label}
              </text>
              <text
                x={lastSeat.cx - 30}//bên trái
                y={lastSeat.cy -10 }
                fontSize="16"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="#000"
              >
                {label}
              </text>
            </g>
          );
        })}

        {/* Tooltip */}
        {hoverSeat && (() => {
          const svgWidth = 2826.295;
          const svgHeight = 2650.823;
          const tooltipHeight = 20;

          const textContent = `Ghế ${hoverSeat.rowChar}${hoverSeat.seatNumber} ${
            hoverSeat.labelGroup
              ? hoverSeat.rowChar !== "A"
                ? `- đoàn ${hoverSeat.labelGroup}`
                : `- ${hoverSeat.labelGroup}`
              : "- ghế trống"
          }`;

          const rawX =
            hoverSeat.cx < svgWidth / 2
              ? hoverSeat.cx + 10
              : hoverSeat.cx - tooltipWidth - 10;

          const finalX = Math.max(0, Math.min(rawX, svgWidth - tooltipWidth));
          const rawY = hoverSeat.cy - 40;
          const finalY = Math.max(0, Math.min(rawY, svgHeight - tooltipHeight));

          const textX = finalX + 5;
          const textY = finalY + 15;

          return (
            <g>
              <rect
                x={finalX}
                y={finalY}
                width={tooltipWidth}
                height={tooltipHeight}
                fill="gray"
                rx="4"
              />
              <text
                ref={textRef}
                x={textX}
                y={textY}
                fontSize="12"
                fill="#fff"
              >
                {textContent}
              </text>
            </g>
          );
        })()}
      </svg>
    </>
  );
}

export default TungSVG_Ok;
